module.exports = "//img4.xes1v1.com/resources/fe-1v1-pclp/img/part3-1.907e33d8.png";